export var WorkspaceCreationContextTypes;
(function (WorkspaceCreationContextTypes) {
    WorkspaceCreationContextTypes["SignUp"] = "Sign Up";
    WorkspaceCreationContextTypes["Manual"] = "Manual";
    WorkspaceCreationContextTypes["Referral"] = "Referral";
})(WorkspaceCreationContextTypes || (WorkspaceCreationContextTypes = {}));
